var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-class=\"$ctrl.containerClass\"> <i ng-class=\"$ctrl.iconClass\" aria-hidden=\"true\"></i> <select2 name=\"busSelect\" ng-required=\"true\" ng-model=\"$ctrl.ngModel\" options=\"$ctrl.queryOptions\" placeholder=\"{{ :: $ctrl.placeholder }}\"> </select2> </div>";
var id1="busSelect.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/core/busSelect.html
// module id = 65
// module chunks = 0 2